import React from 'react';
import FinanceNewsLayout from '../../components/layout/mainNmycorp/FinanceNewsLayout'
import IndustryNewsLayout from '../../components/layout/mainNmycorp/IndustryNewsLayout'
import ThemeNewsLayout from '../../components/layout/mainNmycorp/ThemeNewsLayout'
import moment from "moment";


const MainPage = () => {
    const today = moment().format('YYYY년 MM월 DD일');
    return (
        <div>
            <div className='head_img container'>
                <div className='inner_container' style={{display: 'flex', justifyContent: 'space-between'}}>
                    <p className='head_title'>전체 기업 뉴스 <span>금융시장 뉴스 / 산업 뉴스 / 테마 뉴스</span></p>
                    <p className='head_date'>{today}</p>
                </div>
            </div>
            <FinanceNewsLayout/>
            <div className='inner_container divider_black'/>
            <IndustryNewsLayout/>
            <ThemeNewsLayout/>
        </div>


    );
};

export default MainPage;
